import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Businessmarketing() {
  return (
    <section className="business_marketing p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Why Do Businesses Need <span>Digital Marketing</span> Services in
              2024?
            </h2>
            <p style={{ color: "#898989" }}>
              In 2024, digital marketing is essential as the sector is projected
              to grow at a 9% CAGR. Search marketing alone accounts for 40.9% of
              the global market, with a 12.2% CAGR.
            </p>
            <p style={{ color: "#898989" }}>
              63% of businesses have already increased their digital marketing
              budgets. Additionally, 94% of small businesses plan to boost their
              marketing spending. This upward trend highlights the need for
              robust digital marketing strategies to stay competitive.
            </p>
            <p style={{ color: "#898989" }}>
              Our digital marketing company excels with each campaign we manage.
              Our skilled team of growth marketers develops winning strategies,
              delivers impactful user interactions, and focuses on precision
              retargeting. We position your brand the right way, build valuable
              audiences, and drive recurring conversions.
            </p>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="text-center">
            <StaticImage
              src="../../images/services-usa/digital-marketing/digi-business.webp"
              alt="tekrevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={529}
              height={705}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Businessmarketing;
